module.exports = __webpack_public_path__ + "static/media/mastercard.d3b84061.svg";